// src/services/capacitor/initCapacitor.ts
import { SplashScreen } from '@capacitor/splash-screen';

import { initDeepLinkHandler } from './deepLinkHandler';
import { initNativeSessionManager } from './nativeSessionManager';

export async function initCapacitorServices(websiteKey?: string, locale?: string) {
  try {
    // Initialize deep link handler if we have the required params. Needed for the native app to handle GL redirects.
    if (websiteKey && locale) {
      initDeepLinkHandler(websiteKey, locale);
      initNativeSessionManager(websiteKey, locale);
    }

    // Hide splash screen after initialization
    await SplashScreen.hide();
  } catch (error) {
    console.error('Error initializing Capacitor :', error);
  }
}
